export default __webpack_public_path__ + "img/InterVariable_c504db5.woff2";